<template>
    <div class="all clearfix">
        <Myleft ref="left"></Myleft>
        <div class="grid fl bgff w750 ml10">
           <div class="grid-d">
                <div class="jianshu">
                    <h2 class="ovhidden">
                        <router-link class="cr27 fr fs13" to="">{{dTag}} </router-link>
                        <i class="tag tag-blue" v-if="emotionType == '正面'">正面</i>
                        <i class="tag tag-orange" v-else-if="emotionType == '中性'">中性</i>
                        <i class="tag tag-red" v-else-if="emotionType == '负面'">负面</i>
                        <strong class="ml10">{{title}}</strong>
                    </h2>
                    <p class="mt5 cr77">开始时间 {{beginDate}}</p>
                    <p class="mt5 cr5e">{{description}}</p>
                </div>
            </div>
            <div class="grid-d mt20">
                <div class="grid-header clearfix">
                    <h2 class="title">事件概况</h2>
                </div>
                <div class="grid-body mt15" v-html="hotOver">{{hotOver}}</div>
            </div>
            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title">事件走势</h2>
                </div>
                <div class="grid-body mt15">
                    <div class="echart-warp h305">
                        <lineChart id="hotEvent" :dataArray="hotEventData" v-if="hotEventData != ''" :colorArr="colorArr" :isShowArea="false" gridBot ="60"></lineChart>
                        <div class="no-data" v-if="nodata.hotEventData"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                    </div>
                </div>
            </div>
            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title">媒体分析</h2>
                </div>
                <div class="grid-body mt15">
                    <div class="echart-warp h270">
                        <pieChart id="media" :dataArray="mediaData" v-if="mediaData != ''" :colorArr="mediaColorArr"></pieChart>
                        <div class="no-data" v-if="nodata.mediaData"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                    </div>
                </div>
            </div>

            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title">活跃账号</h2>
                </div>
                <div class="grid-body mt20">
                    <div class="corm clearfix">
                        <span class="element" v-for="(item,index) in activeAccTab" :key="index" @click="choseAccout(index)" :class="{'curr':curIndex == index}">{{item}}</span>
                    </div>
                    <ul class="strip-shape clearfix">
                        <li v-for="(item,index) in activeAccList" :key="index">
                            <div class="people clearfix fl">
                                <img :src="item.icon == '' ? 'static/images/head_img.png' : item.icon" class="img fl"/>
                                <span class="name ovhidden" :title="item.name">{{item.name}}</span>
                            </div>
                            <div class="number fr">
                                <span class="color-blue">{{item.value}}</span>篇
                            </div>
                            <div class="line-warp clearfix">
                                <div class="line">
                                    <div class="in" :style='{width:""+item.percent+""}'></div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="no-data" v-if="nodata.activeAccList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                </div>
            </div>
            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title">首发文章</h2>
                </div>
                <div class="grid-body pb0 mt15">
                    <ul class="article-list">
                        <li class="imgText clearfix">
                            <!-- <router-link class="img fl cp" :to="{path:'eventDetail',query:{id:firNewsList.id}}" target="_blank"><img :src="firNewsList.icon" :onerror="defaultImg"/></router-link> -->
                             <a class="img fl" :href="firNewsList.news_url" target="_blank" v-if="firNewsList.news_img_urls!=undefined">
                                <img :src="firNewsList.isLoadStart?firNewsList.curImg:imgChose(firNewsList,firNewsList.news_img_urls)" :onerror="defaultImg"/>
                            </a>
                            <div class="hidden">
                                <div class="clearfix mt5">
                                    <h2 class="fl ovhidden">
                                        <!-- <router-link class="cr00 cp" :to="{path:'eventDetail',query:{id:firNewsList.id}}" target="_blank">{{firNewsList.news_title}}</router-link> -->
                                        <a class="cr00 cp" :href="firNewsList.news_url" target="_blank">{{firNewsList.news_title}}</a>
                                    </h2>
                                </div>
                                <p class="cr5e mt10 ovhidden2">{{firNewsList.news_digest}}</p>
                                <p class="ziduan mt15 cr77">
                                    <!-- <span v-if="firNewsList.news_source!=''">{{firNewsList.news_source}} ·  </span> -->
                                    <span>{{timeFilter(firNewsList.news_posttime)}}</span>
                                </p>
                            </div>
                        </li>

                    </ul>

                </div>
            </div>
            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title fl">情感属性</h2>
                    <div class="corm fr clearfix">
                        <span class="element" :class="tuType === 'line' ? 'curr' : ''" @click="emotionEchartTab('line');">趋势图</span>
                        <span class="element" :class="tuType === 'pie' ? 'curr' : ''" @click="emotionEchartTab('pie');">饼状图</span>
                    </div>
                </div>
                <div class="grid-body mt15">
                    <div class="echart-warp h270" >
                        <div class="no-data" v-if="tuType === 'pie' && nodata.emotionData2"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                        <lineChart id="emotion1" :dataArray="emotionData1" v-if="tuType === 'line' && emotionData1 != ''"></lineChart>
                        <pieChart id="pieEchart1" :dataArray="emotionData2" :colorArr="emotionColorArr" v-if="tuType === 'pie' && emotionData2 != ''"></pieChart>
                    </div>
                </div>
            </div>

            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title fl">热门主题词</h2>
                    <div class="collection fr clearfix">
                        <span class="tion drop-down">
                            <button class="btn btn-lightblue">{{curHotTheme}}<i class="icons"></i></button>
                            <ul class="option">
                                <li @click="hotThemeTab(index);" v-for="(item,index) of mtType" :key="index">{{item}}</li>
                            </ul>
                        </span>
                    </div>
                </div>
                <div class="grid-body mt15">
                    <div class="echart-warp h270">
                        <div class="no-data" v-if="nodata.defaultWords"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                        <cloudChart id="wordCloud" :dataArray="defaultWords" v-if="hotThemeType == 0 && defaultWords!= ''"></cloudChart>
                        <pieChart v-if="hotThemeType == 1 && hotThemePie != ''" id="pieEchart3" :dataArray="hotThemePie" :showLegend="false"></pieChart>
                        <radarChart v-if="hotThemeType == 2 && hotThemeRadar != ''" id="radarEchart" :dataArray="hotThemeRadar"></radarChart>
                    </div>
                </div>
            </div>

            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title fl">发布地区</h2>
                    <div class="collection fr clearfix">
                        <span class="drop-down mores">
                            <button class="btn btn-lightblue">{{curPublishArea}}<i class="icons"></i></button>
                            <ul class="option pl">
                                <li v-for="(item,index) in areaChoseList" :key="index" @click="changeArea(item,1)">{{item}}</li>
                            </ul>
                        </span>
                    </div>
                </div>
                <div class="grid-body mt15 pd70">
                    <div class="clearfix">
                        <div class="region mt20 fl">
                            <div class="region-header">
                                <span class="span fl">地区</span>
                                <span class="span fl">数量</span>
                            </div>
                            <div class="region-body">
                                <vue-scroll :ops="ops" style="width:160px;height:246px">
                                    <div class="item" v-for="(item,index) in publishAreaData" :key="index">
                                        <span class="span fl">{{item.name}}</span>
                                        <span class="span fl">{{item.value}}</span>
                                    </div>
                                </vue-scroll>
                            </div>
                        </div>
                        <div class="echart-warp hidden h270">
                            <mapChart id="publishArea" :dataArray="publishAreaData" :areaName="curPublishArea" v-if="publishAreaData != ''"></mapChart>
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title fl">提及地区</h2>
                    <div class="collection fr clearfix">
                            <span class="drop-down mores">
                            <button class="btn btn-lightblue">{{curMentionArea === 'top' ? '全国' : curMentionArea}}<i class="icons"></i></button>
                            <ul class="option pl">
                                <li v-for="(item,index) in areaChoseList" :key="index" @click="changeArea(item,2)">{{item}}</li>
                            </ul>
                        </span>
                    </div>
                </div>
                <div class="grid-body mt15 pd70">
                    <div class="clearfix">
                        <div class="region mt20 fl">
                            <div class="region-header">
                                <span class="span fl">地区</span>
                                <span class="span fl">数量</span>
                            </div>
                            <div class="region-body">
                                <vue-scroll :ops="ops" style="width:160px;height:246px">
                                    <div class="item" v-for="(item,index) in mentionAreaData" :key="index">
                                        <span class="span fl">{{item.name}}</span>
                                        <span class="span fl">{{item.value}}</span>
                                    </div>
                                </vue-scroll>
                            </div>
                        </div>
                        <div class="echart-warp hidden h270">
                            <mapChart id="mentionArea" :dataArray="mentionAreaData" :areaName="curMentionArea" v-if="mentionAreaData != ''" ></mapChart>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title">相关文章</h2>
                </div>
                <div class="grid-body pb0 mt15">
                    <ul class="article-list">
                        <li class="imgText clearfix" v-for="(item,index) in commendList" :key="index">
                            <!-- <router-link class="img fl cp" :to="{path:'newsDetail',query:{id:item.id}}" target="_blank">
                                <img :src="item.isLoadStart?item.curImg:imgChose(item)" :onerror="defaultImg"/>
                            </router-link> -->
                            <a class="img fl" :href="item.news_url" target="_blank">
                                <img :src="item.isLoadStart?item.curImg:imgChose(item,item.news_img_urls)" :onerror="defaultImg"/>
                            </a>
                            <div class="hidden">
                                <div class="clearfix mt5">
                                    <h2 class="fl ovhidden">
                                        <!-- <router-link class="cr00 cp" :to="{path:'newsDetail',query:{id:item.id}}" target="_blank">{{item.news_title}}</router-link> -->
                                        <a class="cr00 cp" :href="item.news_url" target="_blank">{{item.news_title}}</a>
                                    </h2>
                                </div>
                                <p class="cr5e mt10 ovhidden2">{{item.news_digest}}</p>
                                <p class="ziduan mt15 cr77">
                                    <!-- <span v-if="item.news_source!=''">{{item.news_source}} ·  </span> -->
                                    <span>{{timeFilter(item.news_posttime)}}</span>
                                </p>
                            </div>
                        </li>

                    </ul>

                </div>
            </div>
        </div>
        <div class="mrCont w310 bgff fr">
            <div class="grid">
                <div class="grid-body">
                    <ul class="jzNews mb20">
                        <ul class="event">
                            <li v-for="(item,index) in hotTopicsList" :key="index">
                                <router-link class="img" :to="{path:'eventTag',query:{id:item.id,type:item.name}}">
                                    <img class="img db" :src="[item.icon]" :onerror="defaultImg"/>
                                    <span class="name ac db">{{item.name}}</span>
                                </router-link>
                            </li>
                        </ul>
                        <div class="no-data pt40" v-if="nodata.hotTopicsList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                    </ul>
                    <div class="no-data pt40" v-if="nodata.hotTopicsList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Myleft from '../../components/left'
import lineChart from '../../components/echart/lineChart.vue';
import pieChart from '../../components/echart/pieChart.vue';
import radarChart from '../../components/echart/radarChart.vue';
import mapChart from '../../components/echart/mapChart.vue';
import cloudChart from '../../components/echart/wordCloud.vue';
export default {
    components: {Myleft,lineChart,pieChart,radarChart,cloudChart,mapChart},
    data() {
        return {
            sid : this.$route.query.id,
            hotTopicsList:[],
            defaultImg:'this.src="static/images/default.png"',
            nodata:{
                hotTopicsList:false,
            },
            emotionType:'',
            dTag:'',
            title:'',
            beginDate:'',
            description:'',
            hotOver:'',
            hotEventData:[],
            mediaData:[],
            mediaColorArr:["#30d258","#e52e45","#f76a44","#ff8121","#2475fb","#1abbf0","#7b37c8","#6a4f77","#c28000","#7dbf2e","#18c391","#4b8abb","#539e79","#d216d2","#bb0000"],
            colorArr:["#56566a","#30d258","#e52e45","#f76a44","#ff8121","#2475fb","#1abbf0","#7b37c8","#6a4f77","#c28000","#7dbf2e","#18c391","#4b8abb","#539e79","#d216d2","#bb0000"],
            curIndex:'total',
            activeAccTab:[],
            activeAccList:[],
            wbAnalysisHtml:{},
            wbAnalysisData:[],//微博分析
            curWbType:'个人认证',
            wbTypeList:[],
            bloggerAllList:[],
            bloggerList:[],//影响力博主
            emotionData1:[],//情感属性折线
            emotionData2:[],//情感属性饼图
            tuType:'pie',//控制图表类型
            emotionColorArr:['#0095eb','#ff8121','#e63349'],
            mtType:['词云图','饼图','雷达图'],//媒体类别
            defaultWords:[],//热门主题词词云图
            wordColors: ['#3c77ce', '#bf3a54', '#2fa130', '#ce393a', '#36accd', '#c64c65'],
            curHotTheme:'词云图',
            hotThemePie:[],//热门主题词饼图
            hotThemeRadar:[],
            hotThemeType:0,
            publishAreaData:[],//发布地区
            areaChoseList:[],
            curPublishArea:'全国',
            mentionAreaData:[],//提及地区
            // isShowMap:true,
            // isShowMention:false,
            curMentionArea:'top',
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',
                }
            },
            gapX:0,
            startx:0,
            endx:0,
            nodata:{
                hotTopicsList:false,
                emotionData2:false,
                defaultWords:false,
                hotEventData:false,
                mediaData:false,
                activeAccList:false,
                bloggerList:false,
            },
            commendList:[],//相关文章
            firNewsList:{},//首发文章
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            // that.hotDataAjax();
            that.dataAjax();
            that.firNewsAjax();
            that.activeAccAjax();
            that.hotThemeAjax();
            that.publishAreaAjax();
            that.mentionAreaAjax();
            that.commendAjax();
        })
    },
    methods: {
        hotDataAjax(){
            let that = this;
            that.$api.get('hotnews/index/tag-list-right',null,r=>{
                that.$parent.returnCode(r,function(){
                    that.hotTopicsList = r.data;
                    if(r.data.list.length<=0){
                        that.nodata.hotTopicsList = true;
                    }else{
                        that.nodata.hotTopicsList = false;
                    }

                });
            });
        },
        dataAjax(){
            let that = this;
            that.$parent.loadModal(true,'数据加载中...');
            //事件详情
            that.$api.get('hotnews/hot-news/info',{sid:that.sid},r=>{
                that.$parent.returnCode(r,function(){
                    that.title = r.data.name;
                    document.title = r.data.name+'_热点';
                    that.beginDate = r.data.beginDate;
                    that.description = r.data.schemeDescription;
                    that.dTag = r.data.tag;
                });
            });
            //事件概括
            that.$api.get('hotnews/hot-news/hot-over-view',{sid:that.sid},r=>{
                that.$parent.returnCode(r,function(){
                    that.hotOver = r.data;
                });
            });
            //事件走势
            that.$api.get('hotnews/hot-news/hot-line-chart',{sid:that.sid},r=>{
                that.$parent.returnCode(r,function(){
                    that.hotEventData = r.data;
                    if(r.data.length<=0){
                        that.nodata.hotEventData = true;
                        return;
                    }else{
                        that.nodata.hotEventData = false;
                    }
                });
            });
            //媒体分析
            that.$api.get('hotnews/hot-news/hot-news-platform-pie',{sid:that.sid},r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.length<=0){
                        that.nodata.mediaData = true;
                        return;
                    }else{
                        that.nodata.mediaData = false;
                    }
                    that.mediaData = r.data;
                });
            });
            //活跃账号
            that.$api.get('monitor/analysis/platform',{sid:that.sid},r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.length<=0){
                        that.nodata.activeAccList = true;
                        return;
                    }else{
                        that.nodata.activeAccList = false;
                    }
                    that.activeAccTab = r.data;
                });
            });
            //微博分析
            that.$api.get('hotnews/hot-news/weibo-analysis',{sid:that.sid},r=>{
                that.$parent.returnCode(r,function(){
                    that.wbAnalysisHtml.html = r.data.descHtml;
                    that.wbAnalysisHtml.artCount = r.data.articleCount;
                    that.wbAnalysisHtml.folCount = r.data.followersCount;
                    that.wbAnalysisHtml.effectMax = r.data.effectMaxType;
                    let wbData = {};
                    wbData.datetime = r.data.keyList;
                    wbData.dataName = ['辐射人群','参与数量'];
                    wbData.data=[];
                    wbData.data.push(r.data.followersNumList);
                    wbData.data.push(r.data.articleNumList);
                    that.wbAnalysisData = wbData;
                });
            });

            //情感属性
            that.$api.get('hotnews/hot-news/sentiment-pie',{sid:that.sid},r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.length<=0){
                        that.nodata.emotionData2 = true;
                        return;
                    }else{
                        that.nodata.emotionData2 = false;
                    }
                    that.emotionData2 = r.data;
                    let max = 0,name = '';
                    r.data.forEach(ele => {
                        if(ele.value>max){
                            max = ele.value;
                            name = ele.name;
                        }
                    });
                    that.emotionType = name;
                });
            });
            that.$api.get('hotnews/hot-news/sentiment-line',{sid:that.sid},r=>{
                that.$parent.returnCode(r,function(){
                    that.emotionData1 = r.data;
                });
            });
        },
        // 首发文章
        firNewsAjax(){
            let that = this;
            that.$api.get('/hotnews/hot-news/first-hotevent',{id:that.sid},r=>{
                that.$parent.loadModal(false);
                that.$parent.returnCode(r,function(){
                    r.data[0].isLoadStart = false;
                    that.firNewsList = r.data[0];
                    that.firNewsList.createTime = that.filter(r.data[0].createTime);
                });
            });
        },
        timeFilter(t){
            var newT = '';
            if(t!=null){
                let tmp = t.split(':');
                newT = tmp[0]+':'+tmp[1];
                return newT;
            }
        },
        // 情感属性图表切换
        emotionEchartTab(type) {
            this.tuType = type;
        },
        //活跃账号切换
        choseAccout(num){
            this.curIndex = num;
            this.activeAccAjax();
        },
        activeAccAjax(){
            let that = this;
            let data= {
                sid:that.sid
            }
            if(that.curIndex != 'total'){
                data.platform = that.curIndex
            };
            that.$api.get('hotnews/hot-news/hot-news-media-top',data,r=>{
                that.$parent.returnCode(r,function(){
                    that.activeAccList = r.data;
                });
            });
        },
        wordClickHandler(name, value, vm) {
            console.log('wordClickHandler', name, value, vm);
        },
        // 热门主题词切换
        hotThemeTab (type) {
            this.hotThemeType = type;
            this.curHotTheme = this.mtType[type];
        },
        // 热门主题词
        hotThemeAjax () {
            let that = this;
            that.$api.get('hotnews/hot-news/hot-key-words',{sid:that.sid},r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.length<=0){
                        that.nodata.defaultWords = true;
                        return;
                    }else{
                        that.nodata.defaultWords = false;
                    }
                    that.defaultWords = r.data;
                    that.hotThemePie = r.data.slice(0,20);
                    that.hotThemeRadar = r.data.slice(0,20);
                });
            });
        },
        // 发布地区
        getAreaType(data){
            let that = this;
            if(that.curPublishArea ==="全国" && that.areaChoseList.length===0){
                //that.curMentionArea = data[0].name;
                data.forEach(ele => {
                    that.areaChoseList.push(ele.name);
                });
                that.areaChoseList.unshift("全国");
            }
        },
        publishAreaAjax(){
            let that = this;
            let dataArgs = {sid:that.sid};
            if(that.curPublishArea!="全国"){
                dataArgs.province = that.curPublishArea
            }
            that.$api.get('hotnews/hot-news/publish-area',dataArgs,r=>{
                that.$parent.returnCode(r,function(){
                    // that.publishAreaData = [];
                    // that.isShowMap = true;
                    // r.data.forEach((ele,index)=>{
                    //     if(ele.value == 0 && (index ==0)){
                    //         ele.value = '-';
                    //         that.publishAreaData.push(ele)
                    //         that.isShowMap = false;
                    //     }if(ele.value != 0){
                    //         that.publishAreaData.push(ele)
                    //     }
                    // });
                    that.publishAreaData = r.data;
                    that.getAreaType(r.data)
                });
            });
        },
        //提及地区
        mentionAreaAjax(){
            let that = this;
            let dataArgs = {sid:that.sid};
            if(that.curMentionArea!="全国"){
                dataArgs.province = that.curMentionArea
            }
            that.$api.get('hotnews/hot-news/mention-area',dataArgs,r=>{
                that.$parent.returnCode(r,function(){
                    that.mentionAreaData = r.data.data;
                    // that.mentionAreaData = [];
                    // that.isShowMention = true;
                    // r.data.data.forEach((ele,index)=>{
                    //     if(ele.value == 0 && (index ==0)){
                    //         ele.value = '-';
                    //         that.mentionAreaData.push(ele)
                    //         that.isShowMention = false;
                    //     }else if(ele.value != 0){
                    //         that.mentionAreaData.push(ele)
                    //     }
                    // });
                    that.curMentionArea = r.data.topProvince;
                    that.getAreaType(r.data.data)
                });
            });
        },
        changeArea(name,type){
            let that = this;
            if(type==1){
                that.curPublishArea = name;
                that.publishAreaAjax();
            }else{
                that.curMentionArea = name;
                that.mentionAreaAjax();
            }

        },
        fatherMethod(name,id){
            let that = this;
            if(id=="publishArea"){
                that.changeArea(name,1)
            }else{
                that.changeArea(name,2)
            }
        },
        //相关文章
        commendAjax(){//ajax
			let that = this;
            that.$api.get('hotnews/hot-news/relate-hotevent',{id:that.sid},r=>{
				that.$parent.returnCode(r,function(){
                    r.data.forEach(ele => {
                        ele.isLoadStart = false
                    });
					that.commendList = r.data;
				})
			});
        },
        loadImg(ele,i,item,len,imgUrls){
            let that= this;
            let img = new Image()
            img.src = ele
            img.onload = function () {
                if(img.width>200 && ((img.width/img.height)<3)){
                    item.curImg = ele;
                    item.isLoadStart = true;
                    //console.log(img.width/img.height)
                    return
                }
                if(i>=(len-1)){
                    item.curImg = '';
                    item.isLoadStart = true;
                    return
                }
                that.loadImg(imgUrls[i+1],(i+1),item,len,imgUrls);
            }
        },
        imgChose(item,imgUrls){
            let that= this,len = imgUrls.length;
            if((len==1 && imgUrls[0]=='') || len==0){
                item.isLoadStart = true;
                item.curImg='';
                return;
            }
           that.loadImg(imgUrls[0],0,item,len,imgUrls);
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/event/eventDetail.vue